module.exports = app_owpp_houseValueLandingPage;